import { graphql } from "~/gql";

export const TAXONOMY_QUERY = graphql(/* GraphQL */ `
  query Taxonomy {
    taxonomy {
      id
      createdAt
      updatedAt
      key
      value
    }
  }
`);

export const UPDATE_TAXONOMY_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateTaxonomy($value: String!, $key: String!, $updateTaxonomyId: Float!) {
    updateTaxonomy(value: $value, key: $key, id: $updateTaxonomyId) {
      id
      createdAt
      updatedAt
      key
      value
    }
  }
`);
